// extracted by mini-css-extract-plugin
export default {"tab":"zWnoKL1jJC-x29jxpch8mA==","has-icon":"dXAIGrGuzvDsJohMWHbX1w==","notification-dot":"EOP9MoCIIZ2ioR5jz1T5Hw==","with-divider":"von3Re+mOl+VXecuxJ2Myw=="};